import { Environment } from './constants';
import { getPublicRuntimeConfig } from './utils/publicRuntimeConfig';

export function environment(): Environment {
  return (getPublicRuntimeConfig('NODE_ENV') || 'development') as Environment;
}

export function isTesting() {
  return environment() === 'test';
}

export function isProduction() {
  return environment() === 'production';
}

export function isDevelopment() {
  return environment() === 'development';
}

/**
 * assertTesting asserts that the currently resolved config's ENVIRONMENT is 'test'
 */

export function assertTesting() {
  if (!isTesting()) {
    throw Error('This code should only be executed in a testing environment.');
  }
}
/**
 * assertNotTesting asserts that the currently resolved config's ENVIRONMENT is
 * not 'test' if there's code that will always fail in tests we want to highlight
 * to the user.
 */

export function assertNotTesting() {
  if (isTesting()) {
    throw Error(
      'This code should only be executed in a non-testing environment.'
    );
  }
}
/**
 * assertNotProduction asserts that the currently resolved config's ENVIRONMENT is not 'production'
 */

export function assertNotProduction() {
  if (isProduction()) {
    throw Error(
      'This code should only be executed in a non production environment.'
    );
  }
}
